import { render, staticRenderFns } from "./SetupAgencyModal.vue?vue&type=template&id=394227a1&"
import script from "./SetupAgencyModal.vue?vue&type=script&lang=ts&"
export * from "./SetupAgencyModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QInput} from 'quasar'
component.options.components = Object.assign({QInput}, component.options.components || {})
